import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeBreakTagPipe'
})
export class RemoveBreakTagPipePipe implements PipeTransform {

  transform(value: string): string {
    let newVal = value.replace('<br/>', '')
    return newVal.charAt(1).toUpperCase() + newVal.slice(2);
  }

}
    